










































































































































































































import { Component, Mixins, Ref, Watch } from 'vue-property-decorator';
import DeviceWidthCheckerMixin from '@/mixins/deviceWidthChecker.mixin';
import APP_UTILITIES from '@/utilities/commonFunctions';
import APP_CONST from '@/constants/AppConst';
import { ScreenText } from '@/lang/ScreenText';
import Stepper, {
  CheckoutStep
} from '@/components/familyPortal/checkout/stepper/Stepper.vue';
import StripeModule from '@/store/modules/stripe/module';
import commonEntry from '@/store/modules/commonEntry';
import PromoCode from '@/components/familyPortal/checkout/promoCode/PromoCode.vue';
import SubmitCard from '@/components/familyPortal/checkout/checkoutSubmitCard/SubmitCard.vue';
import SubmitTotals from '@/components/familyPortal/checkout/checkoutSubmit/SubmitTotals.vue';
import cartStore from '@/store/modules/checkout/cart/module';
import {
  CartApplication,
  StorePolicy,
  SubmitCartItem,
  SubmitOrderDetail,
  SubmitOrderRequest
} from '@/Model/checkout/cart/types';
import {
  ApplicationSubmissionMapperData,
  Enrollments
} from '@/Model/enrollment/types';
import AccountSettings from '@/mixins/accountSettings.mixin';
import { sortSubmitCartItems } from '@/services/checkout/cart/helpers';
import LeaveAlert from '@/popupcomponents/leaveAlert/LeaveAlert.vue';
import { Route } from 'vue-router';
import BouncingPreloader from '@/commoncomponents/bouncingpreloadercomponent/BouncingPreloaderComponent.vue';
import Spinner from '@/commoncomponents/spinner/Spinner.vue';

Component.registerHooks(['beforeRouteEnter']);

@Component({
  components: {
    Spinner,
    BouncingPreloader,
    PromoCode,
    Stepper,
    SubmitCard,
    SubmitTotals,
    LeaveAlert
  }
})
export default class CheckoutSubmit extends Mixins(
  DeviceWidthCheckerMixin,
  AccountSettings
) {
  @Ref('promoCodeMobileComponent') promoCodeMobileComponent?: PromoCode;

  public readonly CheckoutStep = CheckoutStep;
  public readonly screenText = new ScreenText();
  public readonly APP_ROUTES = APP_CONST.APP_ROUTES;
  orderSubmissionInProgress = false;
  orderSubmittedSuccessfully = false;
  hasAttemptedSubmitWithUnappliedPromoCode = false;
  cart = cartStore;
  isLeaveAlertVisible = false;
  shouldLeaveRoute = false;
  nextRoute: any = {};
  shouldBypassLeaveAlert: boolean = false;
  APP_CONST = APP_CONST;

  @Watch('isCartEmpty', { immediate: true })
  onIsCartEmptyChange(isEmpty: boolean) {
    if (isEmpty && !this.orderSubmittedSuccessfully) {
      this.shouldBypassLeaveAlert = true;
      this.$router.push(APP_CONST.APP_ROUTES.CHECKOUT_REVIEW);
    }
  }

  @Watch('cart.promoCode')
  onPromoCodeChange(promoCode: string) {
    if (this.hasAttemptedSubmitWithUnappliedPromoCode && !promoCode) {
      this.hasAttemptedSubmitWithUnappliedPromoCode = false;
    }
  }

  @Watch('orderSubmissionInProgress')
  onOrderSubmissionInProgressChange(orderSubmissionInProgress: boolean) {
    if (this.stripeModule.stripePaymentElement) {
      if (orderSubmissionInProgress) {
        this.stripeModule.stripePaymentElement.update({ readOnly: true });
      }
      else {
        this.stripeModule.stripePaymentElement.update({ readOnly: false });
      }
    }
  }

  stripeModule = StripeModule;
  created() {
    this.onCreated();
  }

  get canSubmitOrder(): boolean {
    return (
      !this.stripeModule.isConfirmingCard &&
      !this.stripeModule.isSubmittingOrder &&
      !this.orderSubmissionInProgress
    );
  }

  get isCartTotalFree() {
    return cartStore.total === 0;
  }

  get showLoadingSpinner(): boolean {
    const fetchingCartDuringOrderSubmission = (cartStore.isFetchingCart && !this.orderSubmissionInProgress && !this.cart.isFetchingCartForPromoCode);
    const fetchingCartAppsDuringOrderSubmission = (cartStore.isFetchingCartApplications && !this.orderSubmissionInProgress);

    return StripeModule.isSettingUpStripe ||
      StripeModule.isCreatingSetupIntent ||
      cartStore.isFetchingStorePolicy ||
      cartStore.isDeleting ||
      this.orderSubmittedSuccessfully ||
      fetchingCartDuringOrderSubmission ||
      fetchingCartAppsDuringOrderSubmission;
  }

  get freeSubmitBtn(): string {
    return this.screenText.getScreenText('BTN_SUBMIT_FREE_ORDER');
  }

  get freeApplicationTitle(): string {
    return this.screenText.getScreenText('FREE_APPLICATION_TITLE');
  }

  get freeApplicationDesc(): string {
    return this.screenText.getScreenText('FREE_APPLICATION_DESC');
  }

  get paymentElementErrorText(): string {
    return this.screenText.getScreenText('CHECKOUT_STEP_SUBMIT_ERROR');
  }

  get confirmCardErrorText(): string {
    const errorCode = this.stripeModule.confirmCardError!.code;
    let errorString = this.stripeModule.confirmCardError!.message;
    if (errorCode === 'processing_error') {
      errorString = errorString!.replace('Try again in a little bit.', '');
    }
    return `${errorString} ${this.screenText.getScreenText(
      'CHECKOUT_STEP_SUBMIT_CARD_ERROR_SUFFIX'
    )}`;
  }

  get submitOrderText(): string {
    return this.screenText.getScreenText('CHECKOUT_STEP_SUBMIT_ORDER');
  }

  get paymentPendingText(): string {
    return this.screenText.getScreenText('CHECKOUT_STEP_SUBMIT_ORDER_PENDING');
  }

  get designColor(): string {
    return commonEntry.accountDesignDetails.accentColor;
  }

  get sortedCartItems(): SubmitCartItem[] {
    return sortSubmitCartItems(cartStore.cartItems);
  }

  get submitOrderDetails(): Array<SubmitOrderDetail> {
    const result: Array<SubmitOrderDetail> = [];
    const cartApplications = cartStore.cartApplications;
    if (cartApplications) {
      for (const cartApplication of cartApplications.cartItemApplicationData) {
        if (!cartApplication.cartItem) {
          // Ensure there is a matching cart item
          continue;
        }
        const enrollments = this.structureFormData(cartApplication);
        if (enrollments) {
          result.push({
            cartItemId: cartApplication.cartItemId,
            sessionId: cartApplication.sessionId,
            productName: `${cartApplication.cartItem.session.programName} - ${cartApplication.cartItem.session.sessionName}`,
            priceId: cartApplication.cartItem.session.priceId,
            taxRateId: cartApplication.cartItem.session.taxRateId,
            enrollments: enrollments,
            price: cartApplication.cartItem.session.price
          });
        }
      }
    }
    return result;
  }

  get isCartEmpty(): boolean {
    return cartStore.isCartEmpty;
  }

  get fetchCartForUserFailed(): boolean {
    return (
      this.cart.didFetchCartFail ||
      this.cart.invalidCartItems.length > 0 ||
      this.cart.invalidItemsRemoved
    );
  }

  get termsOfService(): StorePolicy {
    return cartStore.storePolicy;
  }

  get termsOfServiceUrl(): string {
    const trimmedUrl = this.termsOfService.url.trim();
    let url = '';
    if (this.termsOfService.enabled && trimmedUrl) {
      const hasHttpProtocol = !!trimmedUrl.match(/^http/i);
      url = hasHttpProtocol
        ? this.termsOfService.url
        : `//${this.termsOfService.url}`;
    }
    return url;
  }

  get isPromoCodeInputNotApplied(): boolean {
    return !!this.cart.promoCode && !this.cart.isPromoCodeApplied;
  }

  get hasSubmitUnappliedPromoCodeError(): boolean {
    return this.hasAttemptedSubmitWithUnappliedPromoCode && this.isPromoCodeInputNotApplied;
  }

  get promoCodeNotAppliedErrorMessage(): string {
    return this.hasSubmitUnappliedPromoCodeError
      ? this.screenText.getScreenText('CHECKOUT_PROMO_CODE_NOT_APPLIED_ERROR')
      : '';
  }

  onStay() {
    this.isLeaveAlertVisible = false;
    this.shouldLeaveRoute = false;
  }

  async onYesLeave() {
    this.shouldLeaveRoute = true;
    if (this.nextRoute.name == APP_CONST.APP_ROUTES.DASHBOARD.name || this.nextRoute.name == APP_CONST.APP_ROUTES.FAMILY_PORTAL.name) {
      this.$router.push(APP_CONST.APP_ROUTES.DASHBOARD.path);
    }
    else {
      this.$router.push(this.nextRoute);
    }
  }

  async beforeRouteLeave(to: Route, _from: Route, next: (shouldProceed?: boolean) => void) {
    this.nextRoute = to;
    if (to.path.includes(this.APP_ROUTES.CHECKOUT_DONE.path)
      || to.path.includes(this.APP_ROUTES.LOGIN.path)
      || to.path.includes(this.APP_ROUTES.CHECKOUT_APPLY.path)) {
      next(true);
      return true;
    }
    if (!this.isLeaveAlertVisible && !this.shouldBypassLeaveAlert) {
      this.isLeaveAlertVisible = true;
      next(false);
    }
    if (this.shouldLeaveRoute || this.shouldBypassLeaveAlert) {
      this.isLeaveAlertVisible = false;
      this.shouldBypassLeaveAlert = false;
      await this.$nextTick();
      next(true);
    }
    return true;
  }

  async onCreated() {
    await StripeModule.createSetupIntent();
    await cartStore.fetchCartForUser();

    const setupStripe = async () => {
      if (this.isCartTotalFree) {
        return;
      }
      await this.stripeModule.setupStripe();
    };

    await Promise.all([cartStore.fetchCartApplications(), cartStore.fetchStorePolicy(), setupStripe()]);
    const stripeInitializationFailed =
      this.stripeModule.didSettingUpStripeFail ||
      this.stripeModule.didCreateSetupIntentFail;
    if (!this.isCartTotalFree && stripeInitializationFailed == false) {
      this.stripeModule.createPaymentMethodElement('#payment-element');
    }
  }

  async submitOrder() {
    if (this.canSubmitOrder) {
      this.orderSubmissionInProgress = true;
      // We want to ensure we check this up front so that we can early out before the
      // cart fetch is called to avoid accidentally setting the Promo Code server-side
      if (this.isPromoCodeInputNotApplied) {
        this.hasAttemptedSubmitWithUnappliedPromoCode = true;
        if (this.isMobile && !!this.promoCodeMobileComponent) {
          const promoCodeComponentRect = this.promoCodeMobileComponent.$el.getBoundingClientRect();
          window.scrollTo({
            top: promoCodeComponentRect.top,
            left: promoCodeComponentRect.left,
            behavior: 'smooth'
          });
        }
        this.orderSubmissionInProgress = false;
        return;
      }

      await this.cart.fetchCartForUser();
      if (this.fetchCartForUserFailed) {
        this.orderSubmissionInProgress = false;
        return;
      }

      if (this.cart.promoCodeCartObject && !this.cart.promoCodeCartObject.valid) {
        this.orderSubmissionInProgress = false;
        return;
      }

      await this.cart.fetchCartApplications();
      if (this.cart.didFetchCartApplicationsFail) {
        this.orderSubmissionInProgress = false;
        return;
      }

      if (!this.isCartTotalFree) {
        await this.stripeModule.confirmCard();
        if (this.stripeModule.didConfirmingCardFail) {
          this.orderSubmissionInProgress = false;
          return;
        }
      }

      const { accountId } = await APP_UTILITIES.coreidsAsync();
      const setupIntentId =
        (!this.isCartTotalFree &&
          this.stripeModule.setupIntentResult &&
          this.stripeModule.setupIntentResult.setupIntent &&
          this.stripeModule.setupIntentResult.setupIntent.id) ||
        null;

      const payload: SubmitOrderRequest = {
        cartId: cartStore.activeCartId,
        accountId,
        setupIntentId,
        orderDetails: this.submitOrderDetails,
        promoCode: this.cart.promoCodeCartObject
          ? this.cart.promoCodeCartObject.promoCode
          : undefined
      };

      await this.stripeModule.submitOrder(payload);

      if (!this.stripeModule.didSubmitOrderFail) {
        this.orderSubmittedSuccessfully = true;
        cartStore.configureCartAndApplicationsAfterSubmission();
        this.$router.push(this.APP_ROUTES.CHECKOUT_DONE.path);
      }
    }
    this.orderSubmissionInProgress = false;
  }

  // This is an existing function (structureFormData) lifted from Forms.ts
  structureFormData(cartApplication: CartApplication): Enrollments | null {
    if (
      !cartApplication.applicationInProgress ||
      !cartApplication.elasticSubmissionId
    ) {
      return null;
    }

    // The original implementation used component props for temporarily storing/sorting data while building the structure
    // This instead tracks that internally and passes it along per invocation so we can do it for multiple Applications
    const applicationSubmissionMapperData: ApplicationSubmissionMapperData = {
      builderData: {} as any, // This any is derrived from the existing implementation
      ecs: [],
      ecsOrdered: [],
      existingOrders: [],
      guardianData: {}
    };

    applicationSubmissionMapperData.builderData = {
      scholar: {},
      guardians: {},
      customFields: [],
      emergencyContacts: {
        emergencyContact: [],
        emergencyPhoneNumberType: [],
        emergency_callorder: [],
        emergency_relation: []
      },
      documents: [],
      consents: [],
      siteDetails: {},
      scholarMapping: {
        scholar_Guid: '',
        accountId: cartApplication.applicationInProgress.formsList.accountId,
        applicationId:
          cartApplication.applicationInProgress.formsList.elasticApplicationId,
        submissionId: 0,
        elasticSubmissionId: '',
        programId: 0,
        siteIds: [] as Array<any>
      },
      learning: {},
      medical: {},
      programDetails: {},
      pickUps: {
        authorizedContact: [],
        authorized_relation: [],
        authorizedPhoneNumberType: [],
        authorizedDate: []
      },
      scheduleDays: [],
      guardianList: []
    };

    // Main fields (always present)
    applicationSubmissionMapperData.builderData.scholarMapping.scholar_Guid =
      ''; // This is not absolutely required b/c if empty the BE looks it up based off Scholar first name, last name, DOB, and account ID; since we do not have this currently in the Application data leaving it off for now for MVE
    applicationSubmissionMapperData.builderData.scholarMapping.applicationId =
      cartApplication.applicationInProgress.formsList.applicationGuid;
    applicationSubmissionMapperData.builderData.scholarMapping.elasticSubmissionId =
      cartApplication.elasticSubmissionId;
    applicationSubmissionMapperData.builderData.scholarMapping.siteIds =
      cartApplication.applicationInProgress.siteIds;
    applicationSubmissionMapperData.builderData.scholarMapping.programId =
      cartApplication.applicationInProgress.formsList.programId;
    applicationSubmissionMapperData.builderData.scholarMapping.accountId =
      cartApplication.applicationInProgress.formsList.accountId;

    // Forms
    cartApplication.applicationInProgress.formsList.parts[0].forms.forEach(
      form => {
        this.buildFormData(
          form.formId,
          form.source,
          applicationSubmissionMapperData
        );
      }
    );
    return applicationSubmissionMapperData.builderData;
  }

  // This is an existing function (buildFormData) lifted from Forms.ts
  private buildFormData(
    formId: string,
    source: { [key: string]: unknown },
    applicationSubmissionMapperData: ApplicationSubmissionMapperData
  ) {
    applicationSubmissionMapperData.ecs = [];
    applicationSubmissionMapperData.ecsOrdered = [];
    if (source.list) {
      const sourceList = source.list as Array<any>; // This any is derrived from the existing implementation
      if (sourceList.length) {
        sourceList.forEach(element => {
          const columnName: string = `${element.name}`;
          if (!['dividerLine', 'sectionHeader'].includes(element.name)) {
            if (element.columns) {
              const elementData: any = {};
              const elementContent: any = this.getUpdateFormElements(
                elementData,
                element
              );
              switch (element.group) {
                case 'scholarDetails':
                  if (
                    columnName == 'scholarPhoneNumberType' &&
                    elementContent.scholar_phone &&
                    elementContent.scholar_phone.includes([')', '(', ' '])
                  ) {
                    elementContent.scholar_phone = elementContent.scholar_phone.replace(
                      /\D/g,
                      ''
                    );
                  }
                  applicationSubmissionMapperData.builderData.scholar = {
                    ...applicationSubmissionMapperData.builderData.scholar,
                    [columnName]: elementContent
                  };
                  break;
                case 'guardianDetails':
                  applicationSubmissionMapperData.builderData.guardians = this.getFormattedDetails(
                    applicationSubmissionMapperData.builderData.guardians,
                    columnName,
                    elementContent,
                    applicationSubmissionMapperData,
                    element.order
                  );
                  break;
                case 'customFieldDetails':
                  applicationSubmissionMapperData.builderData.customFields = this.getFormattedDetails(
                    applicationSubmissionMapperData.builderData.customFields,
                    columnName,
                    elementContent,
                    applicationSubmissionMapperData
                  );
                  break;
                case 'emergencyContactsDetails': // Intentional fall-through
                case 'emergencyContactDetails':
                  if (
                    columnName == 'emergencyPhoneNumberType' &&
                    elementContent.emergency_phone &&
                    elementContent.emergency_phone.includes([')', '(', ' '])
                  ) {
                    elementContent.emergency_phone = elementContent.emergency_phone.replace(
                      /\D/g,
                      ''
                    );
                  }
                  this.groupEmergencyContactsData(
                    element,
                    applicationSubmissionMapperData
                  );
                  break;
                case 'scholarSiteDetails':
                  applicationSubmissionMapperData.builderData.siteDetails = {
                    ...applicationSubmissionMapperData.builderData.siteDetails,
                    [columnName]: elementContent
                  };
                  break;
                case 'scholarLearningDetails':
                  applicationSubmissionMapperData.builderData.learning = {
                    ...applicationSubmissionMapperData.builderData.learning,
                    [columnName]: elementContent
                  };
                  break;
                case 'scholarMedicalDetails':
                  applicationSubmissionMapperData.builderData.medical = {
                    ...applicationSubmissionMapperData.builderData.medical,
                    [columnName]: elementContent
                  };
                  break;
                case 'scholarProgramDetails':
                  applicationSubmissionMapperData.builderData.programDetails = {
                    ...applicationSubmissionMapperData.builderData
                      .programDetails,
                    [columnName]: elementContent
                  };
                  break;
                case 'authorizedInfoDetails':
                  applicationSubmissionMapperData.builderData.pickUps = this.getUpdatedFormattedDetails(
                    applicationSubmissionMapperData.builderData.pickUps,
                    elementContent
                  );
                  break;
                case 'authorizedInfo':
                  applicationSubmissionMapperData.builderData.pickUps = this.getFormattedDetails(
                    applicationSubmissionMapperData.builderData.pickUps,
                    columnName,
                    elementContent,
                    applicationSubmissionMapperData
                  );
                  break;
                case 'consentInfo':
                  applicationSubmissionMapperData.builderData.consents.push({
                    consent_Question: elementContent.consent_ques,
                    consent_Answer: elementContent.consent_Label
                      ? elementContent.consent_Label
                      : '',
                    consent_Ack: elementContent.consent_response,
                    consent_Options: `${elementContent.consent_agreement1},${elementContent.consent_agreement}`,
                    elasticform_Id: formId
                  });
                  break;

                default:
                  break;
              }
            }
            else {
              let defaultVal: any = element.options.defaultValue;
              switch (element.group) {
                case 'scholarDetails':
                  applicationSubmissionMapperData.builderData.scholar = {
                    ...applicationSubmissionMapperData.builderData.scholar,
                    [columnName]: defaultVal
                  };
                  break;
                case 'guardianDetails':
                  applicationSubmissionMapperData.builderData.guardians = this.getFormattedDetails(
                    applicationSubmissionMapperData.builderData.guardians,
                    columnName,
                    defaultVal,
                    applicationSubmissionMapperData,
                    element.order
                  );
                  break;
                case 'customFieldDetails':
                  if (Array.isArray(defaultVal) && defaultVal.length) {
                    defaultVal = defaultVal.join(',');
                  }
                  else if (
                    Array.isArray(defaultVal) &&
                    defaultVal.length < 1
                  ) {
                    defaultVal = '';
                  }
                  applicationSubmissionMapperData.builderData.customFields.push(
                    {
                      custom_Response: defaultVal,
                      custom_Field: columnName,
                      custom_Question: element.label
                    }
                  );
                  break;
                case 'emergencyContactsDetails': // Intentional fall-through
                case 'emergencyContactDetails':
                  this.groupEmergencyContactsData(
                    element,
                    applicationSubmissionMapperData
                  );
                  break;
                case 'scholarSiteDetails':
                  applicationSubmissionMapperData.builderData.siteDetails = {
                    ...applicationSubmissionMapperData.builderData.siteDetails,
                    [columnName]: defaultVal
                  };
                  break;
                case 'scholarLearningDetails':
                  applicationSubmissionMapperData.builderData.learning = {
                    ...applicationSubmissionMapperData.builderData.learning,
                    [columnName]: defaultVal
                  };
                  break;
                case 'scholarMedicalDetails':
                  applicationSubmissionMapperData.builderData.medical = {
                    ...applicationSubmissionMapperData.builderData.medical,
                    [columnName]: defaultVal
                  };
                  break;
                case 'scholarProgramDetails':
                  applicationSubmissionMapperData.builderData.programDetails = {
                    ...applicationSubmissionMapperData.builderData
                      .programDetails,
                    [columnName]: defaultVal
                  };
                  break;
                case 'authorizedInfoDetails':
                  applicationSubmissionMapperData.builderData.pickUps = this.getFormattedDetails(
                    applicationSubmissionMapperData.builderData.pickUps,
                    columnName,
                    defaultVal,
                    applicationSubmissionMapperData
                  );
                  break;
                case 'authorizedInfo':
                  applicationSubmissionMapperData.builderData.pickUps = this.getFormattedDetails(
                    applicationSubmissionMapperData.builderData.pickUps,
                    columnName,
                    defaultVal,
                    applicationSubmissionMapperData
                  );
                  break;
                default:
                  break;
              }
            }
          }
        });
        this.prepareEmergencyContactDetails(applicationSubmissionMapperData);
      }
    }
  }

  // This is an existing function (getUpdateFormElements) lifted from Forms.ts
  private getUpdateFormElements(
    elementData: any,
    element: any,
    parentItemName?: any
  ) {
    element.columns.forEach((column: any) => {
      /* istanbul ignore else */
      if (column.list) {
        column.list.forEach((listItem: any) => {
          if (
            listItem.name != APP_CONST.DIVIDERLINE_TEXT &&
            listItem.name != APP_CONST.TEXTAREALONGQUESTION_TEXT
          ) {
            if (listItem.columns) {
              if (
                element.name == 'emergencyContact' ||
                element.name == 'authorizedInformation'
              ) {
                this.getUpdateFormElements(
                  elementData,
                  listItem,
                  listItem.name
                );
              }
              else {
                this.getUpdateFormElements(elementData, listItem);
              }
            }
            else {
              if (listItem.type == 'consentcheckbox') {
                elementData[listItem.name] =
                  listItem.options.options &&
                  listItem.options.options[0] &&
                  listItem.options.options[0].value;
                if (listItem.options.defaultValue) {
                  elementData['consent_Label'] =
                    listItem.options.options &&
                    listItem.options.options[0] &&
                    listItem.options.options[0].value;
                }
              }
              else {
                if (
                  listItem.name.includes('emergency') ||
                  listItem.name.includes('authorized')
                ) {
                  if (parentItemName) {
                    parentItemName =
                      parentItemName == 'emergencyContactName'
                        ? 'emergencyContact'
                        : parentItemName == 'authorizedInformation'
                          ? 'authorizedContact'
                          : parentItemName;
                    elementData[parentItemName] = {
                      ...elementData[parentItemName],
                      [listItem.name]: listItem.options.defaultValue
                    };
                  }
                  else {
                    elementData[listItem.name] = listItem.options.defaultValue;
                  }
                }
                else {
                  elementData[listItem.name] = listItem.options.defaultValue;
                }
              }
            }
          }
        });
      }
    });
    return elementData;
  }

  // This is an existing function (getFormattedDetails) lifted from Forms.ts
  private getFormattedDetails(
    data: any,
    column: string,
    content: any,
    applicationSubmissionMapperData: ApplicationSubmissionMapperData,
    order?: any
  ) {
    /* istanbul ignore else */
    if (
      typeof content != 'undefined' &&
      column != APP_CONST.DIVIDERLINE_TEXT &&
      column != APP_CONST.TEXTAREALONGQUESTION_TEXT
    ) {
      if (data[column]) {
        if (
          (column.includes('guardian') && data[column].length < 2) ||
          !column.includes('guardian')
        ) {
          if (
            order &&
            (!applicationSubmissionMapperData.guardianData[column] ||
              (applicationSubmissionMapperData.guardianData[column] &&
                applicationSubmissionMapperData.guardianData[column] != order))
          ) {
            applicationSubmissionMapperData.guardianData = {
              ...applicationSubmissionMapperData.guardianData,
              [column]: order
            };
            data[column][data[column].length] = content;
            // swap if guardian 2 at index 0 and when 2 guardians are alraedy added
            if (
              data[column].length == 2 &&
              column.includes('guardian') &&
              order == 'guardian_1'
            ) {
              data[column] = [data[column][1], data[column][0]];
            }
          }
          else if (!column.includes('guardian')) {
            data[column][data[column].length] = content;
          }
        }
        else if (
          column.includes('guardian') &&
          data[column].length < APP_CONST.TWO
        ) {
          data[column][data[column].length] = content;
        }
      }
      else {
        if (column.includes('guardian') && order) {
          applicationSubmissionMapperData.guardianData = {
            ...applicationSubmissionMapperData.guardianData,
            [column]: order
          };
        }
        data = { ...data, [column]: [content] };
      }
    }
    // This was in the existing implemenation, but since this func is directly manipulating the obj ref, it seems unnecessary
    return data;
  }

  // This is an existing function (groupEmergencyContactsData) lifted from Forms.ts
  private groupEmergencyContactsData(
    element: any,
    applicationSubmissionMapperData: ApplicationSubmissionMapperData
  ) {
    const columnName = `${element.name}`;
    let orderIndex = -1;
    let groupName = '';
    if (groupName == '' && element.group != undefined && element.group != '') {
      groupName = element.group;
    }

    if (
      columnName == 'emergency_callorder' &&
      element.options.defaultValue != undefined &&
      element.options.defaultValue != ''
    ) {
      orderIndex = parseInt(element.options.defaultValue);
      if (
        applicationSubmissionMapperData.ecs[applicationSubmissionMapperData.ecs.length - 1]
      ) {
        applicationSubmissionMapperData.ecs[
          applicationSubmissionMapperData.ecs.length - 1
        ].orderIndex = orderIndex;
      }
      applicationSubmissionMapperData.existingOrders.push(orderIndex);
    }

    if (columnName == 'emergencyContact') {
      if (
        applicationSubmissionMapperData.ecs.length > 0 &&
        applicationSubmissionMapperData.ecs[
          applicationSubmissionMapperData.ecs.length - 1
        ].orderIndex == undefined
      ) {
        applicationSubmissionMapperData.ecs[
          applicationSubmissionMapperData.ecs.length - 1
        ].orderIndex = orderIndex;
      }
      applicationSubmissionMapperData.ecs.push({
        orderIndex: -1,
        items: new Array()
      });
    }
    applicationSubmissionMapperData.ecs[
      applicationSubmissionMapperData.ecs.length - 1
    ] &&
      applicationSubmissionMapperData.ecs[
        applicationSubmissionMapperData.ecs.length - 1
      ].items.push(element);
  }

  // This is an existing function (getUpdatedFormattedDetails) lifted from Forms.ts
  private getUpdatedFormattedDetails(data: any, content: any) {
    /* istanbul ignore else */
    if (typeof content != 'undefined') {
      if (Object.keys(content).length) {
        Object.keys(content).forEach((elemKey: any) => {
          if (elemKey in content) {
            data[elemKey].push(content[elemKey]);
          }
        });
      }
    }
    return data;
  }

  // This is an existing function (prepareEmergencyContactDetails) lifted from Forms.ts
  private prepareEmergencyContactDetails(
    applicationSubmissionMapperData: ApplicationSubmissionMapperData
  ) {
    let i: number = 0;
    let j: number = 0;
    applicationSubmissionMapperData.ecsOrdered = JSON.parse(
      JSON.stringify(applicationSubmissionMapperData.ecs)
    );
    const groupName: string = '';

    for (i = 0; i < applicationSubmissionMapperData.ecs.length; i++) {
      if (applicationSubmissionMapperData.ecs[i].orderIndex == -1) {
        for (j = 0; j < applicationSubmissionMapperData.ecs.length; j++) {
          if (
            applicationSubmissionMapperData.existingOrders.indexOf(j + 1) == -1
          ) {
            applicationSubmissionMapperData.ecs[i].orderIndex = j + 1;
            applicationSubmissionMapperData.ecs[i].items.push({
              options: { defaultValue: (j + 1).toString() },
              name: 'emergency_callorder',
              group: groupName == ''
                ? 'emergencyContactDetails'
                : groupName
            });
            applicationSubmissionMapperData.existingOrders.push(j + 1);
            break;
          }
        }
      }
    }
    applicationSubmissionMapperData.ecs.sort((a: any, b: any) =>
      a.orderIndex > b.orderIndex
        ? 1
        : -1
    );

    for (i = 0; i < applicationSubmissionMapperData.ecs.length; i++) {
      for (
        j = 0;
        j < applicationSubmissionMapperData.ecs[i].items.length;
        j++
      ) {
        const element = applicationSubmissionMapperData.ecs[i].items[j];
        const columnName = `${element.name}`;

        if (!['dividerLine', 'sectionHeader'].includes(element.name)) {
          if (element.columns) {
            const elementData = {};
            const elementContent = this.getUpdateFormElements(
              elementData,
              element
            );
            switch (element.group) {
              case 'emergencyContactsDetails':
                if (
                  columnName == 'emergencyPhoneNumberType' &&
                  elementContent.emergency_phone &&
                  elementContent.emergency_phone.includes([')', '(', ' '])
                ) {
                  elementContent.emergency_phone = elementContent.emergency_phone.replace(
                    /\D/g,
                    ''
                  );
                }
                applicationSubmissionMapperData.builderData.emergencyContacts = this.getUpdatedFormattedDetails(
                  applicationSubmissionMapperData.builderData.emergencyContacts,
                  elementContent
                );

                break;
              case 'emergencyContactDetails':
                if (
                  columnName == 'emergencyPhoneNumberType' &&
                  elementContent.emergency_phone &&
                  elementContent.emergency_phone.includes([')', '(', ' '])
                ) {
                  elementContent.emergency_phone = elementContent.emergency_phone.replace(
                    /\D/g,
                    ''
                  );
                }
                applicationSubmissionMapperData.builderData.emergencyContacts = this.getFormattedDetails(
                  applicationSubmissionMapperData.builderData.emergencyContacts,
                  columnName,
                  elementContent,
                  applicationSubmissionMapperData
                );
                break;
            }
          }
          else {
            const defaultVal = element.options.defaultValue;
            switch (element.group) {
              case 'emergencyContactsDetails':
                break;
              case 'emergencyContactDetails':
                if (
                  (columnName === 'emergency_callorder' ||
                    columnName === 'emergency_relation') &&
                  defaultVal != 'Select'
                ) {
                  // This if below was added in PROD-123 to prevent duplicates in the callorder with the new flow
                  if (
                    columnName === 'emergency_callorder' &&
                    applicationSubmissionMapperData.builderData.emergencyContacts.emergency_callorder.includes(
                      defaultVal
                    )
                  ) {
                    break;
                  }
                  applicationSubmissionMapperData.builderData.emergencyContacts = this.getFormattedDetails(
                    applicationSubmissionMapperData.builderData
                      .emergencyContacts,
                    columnName,
                    defaultVal,
                    applicationSubmissionMapperData
                  );
                }
                break;
            }
          }
        }
      }
    }
  }

  destroyed() {
    this.stripeModule.reset();
  }
}
